<template>
    <div>
        <div class="form-group row align-items-end">
            <div class="col-4">
                <div class="search">
                    <input type="text" @input="Search" v-model="Filtro.Nombre" class="form-control p-icon"
                        :placeholder="Filtro.Placeholder" size="40" autocomplete="off">
                </div>
            </div>
            <div class="col-4">
                <label for="">Fecha Inicial</label>
                <Datepicker name="FechaSalida" @input="ValidarYBuscar('FI')" id="FechaSalida" v-model="Filtro.FechaI"
                    :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma"
                    placeholder="0000-00-00">
                </Datepicker>
            </div>
            <div class="col-4">
                <label for="">Fecha Final</label>
                <Datepicker name="FechaSalida" @input="ValidarYBuscar('FF')" id="FechaSalida" v-model="Filtro.FechaF"
                    :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma"
                    placeholder="0000-00-00">
                </Datepicker>
            </div>
        </div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="table-responsive pb-0">
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th :class="StyleTh + ' text-center'">#</th>
                                <th :class="StyleTh">Folio</th>
                                <th :class="StyleTh">Fecha</th>
                                <th :class="StyleTh">Cliente</th>
                                <th :class="StyleTh">RFC</th>
                                <th :class="StyleTh">Método de pago</th>
                                <th :class="StyleTh">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(lista, index) in ListaArrayRows" :key="index" @click="Seleccionar(lista.UUID)">
                                <td class="text-center">
                                    <p :class="StyleTd">{{ (index + 1) }}</p>
                                </td>
                                <td>
                                    <h6 :class="StylePr">{{ lista.Serie }} - {{ lista.Folio }}</h6>
                                </td>
                                <td>
                                    <p :class="StyleTd">{{ lista.FechaRegistro }}</p>
                                </td>
                                <td>
                                    <p :class="StyleTd">{{ lista.NombreCliente }}</p>
                                </td>
                                <td>
                                    <p :class="StyleTd">{{ lista.RfcCliente }}</p>
                                </td>
                                <td>
                                    <p :class="StyleTd">{{ lista.MetodoPago }}</p>
                                </td>
                                <td>
                                    <button v-if="lista.AddBtn" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary me-2"></i> Agregar</button>
                                </td>
                            </tr>
                            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
                        </tbody>
                    </table>
                </div>
            </template>
        </CLoader>
    </div>
</template>

<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
import Calendar from '@/helpers/StaticComboBox.js';
const EmitEjecuta = 'seccionCpFacturas';

export default {
    name: 'ListaCp_Pais',
    props: ['poBtnSave'],
    components: {
    },
    data() {
        return {
            ConfigList: {
                Title: 'Listado',
                BtnNewShow: false,
                BtnReturnShow: false,
                ShowEntradas: false,
                ShowPaginador: false,
                ShowFooter: false,
                IsModal: true,
                ShowYear: false,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                TitleFirst: '',
            },
            Filtro: {
                Nombre: '',
                FechaI: '',
                FechaF: new Date(),
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar por Folio',
            },
            ConfigModal: {
                ModalTitle: "Formulario",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
            },
            ConfigLoad: {
                ShowLoader: true,
                ClassLoad: true,
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            IdAgente:0,
            Emit:this.poBtnSave.EmitSeccion,
            ListaArrayRows: [],
            ListaUuidAgregados:[],
            TimeOut: null,
            Setpicker: Calendar.calendarSettings,
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
        async Lista() {
            this.ConfigLoad.ShowLoader = true;

            await this.$http.get("cpDataFacturasTimbrado", {
                params: {
                    TxtBusqueda: this.Filtro.Nombre,
                    FechaI: this.Filtro.FechaI,
                    FechaF: this.Filtro.FechaF,
                    Entrada: 100,
                    Pag: 1,
                }
            }).then((res) => {
                this.ListaArrayRows = res.data.data;
                this.ListaArrayRows = [
                    {UUID:'LH51335G1L3JG51L3JG1153',
                    FechaRegistro:'2023/10/10',
                    NombreCliente:'Karla Fuentes Nolasco',
                    RfcCliente:'KN23K232HY01',
                    Serie:12,
                    MetodoPago:'Efectivo',
                    Folio:'FOL139'},
                    {UUID:'897D8NGF7S8FDG7N0SDF87G0S',
                    FechaRegistro:'2023/10/10',
                    NombreCliente:'Karla Fuentes Nolasco',
                    RfcCliente:'KN23K232HY01',
                    Serie:12,
                    MetodoPago:'Efectivo',
                    Folio:'FOL139'},
                    {UUID:'098A78DSF7AD8F7A0SDFABMV3',
                    FechaRegistro:'2023/10/10',
                    NombreCliente:'Karla Fuentes Nolasco',
                    RfcCliente:'KN23K232HY01',
                    Serie:12,
                    MetodoPago:'Efectivo',
                    Folio:'FOL139'},
                ];
                this.ListaArrayRows.forEach(elem => {
                    let isAdded = this.ListaUuidAgregados.some(elem2 => elem2.IdDocumentoRelacionado == elem.UUID)
                    elem['AddBtn'] = !isAdded; 
                })
                this.segurity = res.data.segurity;
            }).finally(() => {
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Search() {
            if (this.Filtro.Nombre != '') {
                clearTimeout(this.TimeOut);
                this.TimeOut = setTimeout(() => {
                    this.Lista();
                }, 1000);
            }
        },
        Eliminar(Id) {
            this.$swal(Configs.configEliminar).then((result) => {
                if (result.value) {
                    this.$http.delete('cpPaises/' + Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                }
            });
        },
        ValidarYBuscar(fecha) {
            if (this.Filtro.FechaF && this.Filtro.FechaI) {
                if (this.Filtro.FechaI > this.Filtro.FechaF) {
                    if (fecha === 'FI') {
                        this.$toast.warning('La fecha inicial no puede ser mayor que la fecha final.');
                        this.Filtro.FechaI = this.Filtro.FechaF;
                    } else {
                        this.Filtro.FechaF = this.Filtro.FechaI;
                        this.$toast.warning('La fecha final no puede ser menor que la fecha inicial.');
                    }
                    return false;
                }
            }
            if(this.Filtro.FechaF || this.FiltroFechaI){
                this.Lista();
            }
        },
        Seleccionar(Id) {
            this.bus.$emit('AgregarFactura_'+this.Emit,Id)
            this.bus.$emit('CloseModal_'+this.Emit);
        },
    },
    created() {
      	this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id,Obj)=>
        {   
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;
            if (Id!='') 
            {
                // this.IdAgente = Id;
                // this.ListaUuidAgregados = Obj;
                // this.Lista();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
            this.IdAgente = Id;
            this.ListaUuidAgregados = Obj;
            this.Lista();
        });
    
    },
}
</script>
